import initialState from '../../data/follow'
import ActionTypes from '../constants/action-types'

const followReducer = (state = initialState, action) => {
  // console.log('type: ' + action.type + ' -- payload: ' + action.payload);
  switch(action.type) {
    case ActionTypes.SET_PROCESSING_FOLLOW: return {...state, isProcessing: action.payload}
    
    default: return state
  }
}

export default followReducer